import { render, staticRenderFns } from "./comprehensiveForm.vue?vue&type=template&id=4070a482&scoped=true&"
import script from "./comprehensiveForm.vue?vue&type=script&lang=js&"
export * from "./comprehensiveForm.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveForm.vue?vue&type=style&index=0&id=4070a482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070a482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4070a482')) {
      api.createRecord('4070a482', component.options)
    } else {
      api.reload('4070a482', component.options)
    }
    module.hot.accept("./comprehensiveForm.vue?vue&type=template&id=4070a482&scoped=true&", function () {
      api.rerender('4070a482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vab/form/comprehensiveForm.vue"
export default component.exports